import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class UpdatePhotoService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public savePhoto(id: string, formData: FormData): Observable<null> {
    return this.httpClient
      .put<null>(`${this.baseUrl}${ApiEndpoints.GET_USER}/${id}/profile-image`, formData)
      .pipe(take(1));
  }

  public deletePhoto(id: string): Observable<null> {
    return this.httpClient
      .delete<null>(`${this.baseUrl}${ApiEndpoints.GET_USER}/${id}/profile-image`)
      .pipe(take(1));
  }
}
